export type RecoCarouselTitleProps = {
  title: string;
  preferTitle?: boolean;
  loadingState: boolean;
};

export const RecoCarouselTitle = ({ title, preferTitle, loadingState }: RecoCarouselTitleProps) => {
  if (preferTitle && !title) return null;

  return (
    <div className="text-size-headline-xl lg:text-size-headline-2xl my-2 px-1.5 lg:px-2">
      {loadingState ? (
        <div className="bg-color-grey h-4 w-[200px] animate-pulse" />
      ) : (
        <p>{title}</p>
      )}
    </div>
  );
};
